module.exports = __webpack_public_path__ + "img/gradient_gruen.0fdd82d4.svg";